<template>
  <div class="md-layout md-alignment-center-center callback-container gray-6 bg">
    <p v-if="state.error" class="error">{{ state.error.message || state.error.errorDescription || 'Unkown error during authentication' }}</p>
    <router-link v-if="state.error" to="login">Back to login</router-link>
    <h3 v-if="!state.error">Logging you in...</h3>
    <md-progress-spinner v-if="!state.error" md-mode="indeterminate" />
  </div>
</template>

<script>
import auth, { groupsDataKey } from '~lib/common/providers/auth';
import getSafeRedirectUrl from '~lib/common/utils/getSafeRedirectUrl';

export default {
  name: 'login-callback',
  data() {
    return {
      state: {
        error: null,
        displayOrgSelection: false,
      },
    };
  },
  async mounted() {
    try {
      const { query } = this.$route;
      await auth.handleAuthentication();
      const groupsData = JSON.parse(localStorage.getItem(groupsDataKey));
      const orgGroups = groupsData.filter(group => !group.metadata.parent);

      const safeRedirectUrl = getSafeRedirectUrl(query.redirectUrl);
      if (safeRedirectUrl) {
        window.location.href = safeRedirectUrl;
        return;
      }

      if (orgGroups.length > 1) {
        this.$router.replace({ name: 'org-selection' });
      } else {
        this.$router.replace({ name: 'verifyEmail' });
      }
    } catch (error) {
      console.error(error);
      this.state.error = error;
    }
  },
};
</script>

<style>
.callback-container {
  flex-direction: column;
}
</style>
